const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { availableOperationsQuery } from '@/features/authentication/services/permissionQueries';
import { LOGIN_ROUTE, waitForAuth } from '@/shared/lib/authSession';
import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({
    context
  }) => {
    const user = await waitForAuth();
    if (!user) {
      throw redirect({
        to: LOGIN_ROUTE
      });
    }
    if (!user.emailVerified) throw redirect({
      to: '/login-complete'
    });
    await context.queryClient.prefetchQuery(availableOperationsQuery(user.uid));
    return {
      authUid: user.uid
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});